import ComboBoxFormik from "@/common/components/form/ComboBoxFormik"
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading"
import { updateMeasuredUnit } from "@/common/services/product.api"
import { TYPE_MEASUREDUNIT } from "@/types/product.types"
import { Modal } from "flowbite-react"
import { FormikProvider, useFormik } from "formik"
import { useState } from "react"

type Props = {
    onClose: () => void
    measuredunit: string
    productId: string
}

function ChangeMeasuredUnit(props: Props) {
    const handleCloseModal = () => { props.onClose && props.onClose() };
    const [loading, setLoading] = useState(false);

    const handle = async data => {
        setLoading(true);
        await updateMeasuredUnit({ productId: props.productId as string, measuredunit: data.measuredunit });
        setLoading(false);
        handleCloseModal();
    }

    const formik = useFormik({
        initialValues: { measuredunit: props.measuredunit },
        onSubmit: handle
    })

    return (
        <Modal
            className='relative text-black'
            show={true}
            onClose={() => handleCloseModal()}
        >
            <Modal.Header >
                <h2 className='text-black'>Altere o tipo de unidade da peça</h2>
            </Modal.Header>
            <Modal.Body className='text-black dark:text-black'>
                <FormikProvider value={formik} >
                    <ComboBoxFormik
                        name="measuredunit"
                        label="Selecione o tipo"
                        options={[props.measuredunit != TYPE_MEASUREDUNIT.UNID ? { label: props.measuredunit, value: props.measuredunit } : { label: "-", value: "" }, ...Object.values(TYPE_MEASUREDUNIT).map(el => ({ label: el, value: el })).filter(el => el.value != props.measuredunit)]}
                    />
                </FormikProvider>
                <ButtonWithLoader isLoading={loading} onClick={() => handle(formik.values)}>Alterar</ButtonWithLoader>

            </Modal.Body>
        </Modal>
    )
}

export default ChangeMeasuredUnit